import React from "react";
import FluidImage from "../../../components/fluidImage";

const ServiceHero = (props) => {

    const blok = props.blok

    return (
        <section className="width grid lg:grid-cols-12 mt-[22rem] lg:mt-72 lg:gap-20 unpad">

            <div className="lg:col-span-5 aspect-[375/250] lg:aspect-[489/600] lg:ml-14">
                <FluidImage image={blok.image} />
            </div>
            <div className="lg:col-span-7 flex flex-col items-start justify-start pt-2 lg:pt-24 max-w-2xl mobile:order-first px-5 lg:px-0 pb-10 lg:pb-0">
                <p className="text-3x lg:text-3xl font-semibold pb-6 lg:pb-8 uppercase">
                {blok.title}
                </p>
                <h2 className="text-3xl lg:text-53 font-extralight font-serif">
                    {blok.large_copy}
                </h2>
                {blok.small_copy != "" && (
                    <p className="text-lg pb-8 pt-12 lg:text-3xl font-medium hidden lg:block">
                        {blok.small_copy}
                    </p>
                )}

            </div>
            <div className="lg:hidden px-5 pt-8">
                <p className="text-[25px] font-medium">
                    {blok.tagline}
                </p>

            </div>
        </section>
    )
}

export default ServiceHero